export interface IAnimatedButtonParams {
    defaultBackgroundRGBAHex: string;
    defaultTextRGBAHex: string;
    defaultUnderlineRGBAHex: string;
    defaultBorderRGBAHex: string;

    hoverBackgroundRGBAHex: string;
    hoverTextRGBAHex: string;
    hoverBorderRGBAHex: string;

    borderRadius: string;
    needsBackgroundPadding: boolean;
    doTextSpinAnimation: boolean;
    invertLineVisibility: boolean;
}

export function blackBlueNoBG(): IAnimatedButtonParams {
    const params: IAnimatedButtonParams = {
        defaultBackgroundRGBAHex: '#FFFFFF00',      // white transparent
        defaultTextRGBAHex: '#000000',              // black
        defaultUnderlineRGBAHex: '#0076B2',         // blue
        defaultBorderRGBAHex: '#FFFFFF00',          // white transparent

        hoverBackgroundRGBAHex: '#FFFFFF00',       // white transparent
        hoverTextRGBAHex: '#000000',                // black
        hoverBorderRGBAHex: '#FFFFFF00',           // white transparent
        borderRadius: "0",
        needsBackgroundPadding: false,
        doTextSpinAnimation: true,
        invertLineVisibility: true
    };
    return params;
}

export function blackBlackNoBG(): IAnimatedButtonParams {
    const params: IAnimatedButtonParams = {
        defaultBackgroundRGBAHex: '#FFFFFF00',     // white transparent
        defaultTextRGBAHex: '#000000',              // black
        defaultUnderlineRGBAHex: '#000000',         // black
        defaultBorderRGBAHex: '#FFFFFF00',          // white transparent

        hoverBackgroundRGBAHex: '#FFFFFF00',       // white transparent
        hoverTextRGBAHex: '#000000',                // black
        hoverBorderRGBAHex: '#FFFFFF00',           // white transparent
        borderRadius: "0",
        needsBackgroundPadding: false,
        doTextSpinAnimation: true,
        invertLineVisibility: true
    };
    return params;
}

export function whiteWhiteNoBG(): IAnimatedButtonParams {
    const params: IAnimatedButtonParams = {
        defaultBackgroundRGBAHex: '#FFFFFF00',     // white transparent
        defaultTextRGBAHex: '#FFFFFF',              // white
        defaultUnderlineRGBAHex: '#FFFFFF',         // white
        defaultBorderRGBAHex: '#FFFFFF00',          // white transparent

        hoverBackgroundRGBAHex: '#FFFFFF00',       // white transparent
        hoverTextRGBAHex: '#FFFFFF',                // white
        hoverBorderRGBAHex: '#FFFFFF00',           // white transparent
        borderRadius: "0",
        needsBackgroundPadding: false,
        doTextSpinAnimation: true,
        invertLineVisibility: true
    };
    return params;
}

export function blackNoLineWhiteBG(): IAnimatedButtonParams {
    const params: IAnimatedButtonParams = {
        defaultBackgroundRGBAHex: '#FFFFFF00',      // white transparent
        defaultTextRGBAHex: '#000000',              // black
        defaultUnderlineRGBAHex: '#FFFFFF00',       // white transparent
        defaultBorderRGBAHex: "var(--csb-color-dark)",            // grey

        hoverBackgroundRGBAHex: '#FFFFFF00',        // white transparent
        hoverTextRGBAHex: '#000000',                // black
        hoverBorderRGBAHex: '#0076B2',              // blue
        borderRadius: "0",
        needsBackgroundPadding: true,
        doTextSpinAnimation: true,
        invertLineVisibility: true
    };
    return params;
}

export function animTextNoLineWhiteBlueBG(): IAnimatedButtonParams {
    const params: IAnimatedButtonParams = {
        defaultBackgroundRGBAHex: '#FFFFFF',        // white
        defaultTextRGBAHex: '#000000',              // black
        defaultUnderlineRGBAHex: '#FFFFFF00',       // white transparent
        defaultBorderRGBAHex: '#FFFFFF',            // white

        hoverBackgroundRGBAHex: '#0076B2',          // blue
        hoverTextRGBAHex: '#FFFFFFFF',              // white
        hoverBorderRGBAHex: '#0076B2',              // blue
        borderRadius: "0",
        needsBackgroundPadding: true,
        doTextSpinAnimation: true,
        invertLineVisibility: false
    };
    return params;
}

export function animTextNoLineBlackBlueBG(): IAnimatedButtonParams {
    const params: IAnimatedButtonParams = {
        defaultBackgroundRGBAHex: '#1D2021',        // dark gray
        defaultTextRGBAHex: '#FFFFFF',              // white
        defaultUnderlineRGBAHex: '#FFFFFF00',       // white transparent
        defaultBorderRGBAHex: '#1D2021',            // dark gray

        hoverBackgroundRGBAHex: '#0076B2',          // blue
        hoverTextRGBAHex: '#FFFFFF',                // white
        hoverBorderRGBAHex: '#0076B2',              // blue
        borderRadius: "0",
        needsBackgroundPadding: true,
        doTextSpinAnimation: true,
        invertLineVisibility: false
    };
    return params;
}

export interface IAnimatedButtonIconParams {
    name: string;
    color: string;
    size: number;
    direction: string;
    className: string;
}

export function createButtonIcon(name: string = "search", color: string = "#000000", size: number = 16, direction: string = "left"): IAnimatedButtonIconParams {
    const params: IAnimatedButtonIconParams = {
        name: name,
        color: color,
        size: size,
        direction: direction,
        className: 'icon'
    };
    return params;
}

export interface IAnimatedButtonFontParams {
    heightInPx: number;
    lineHeight: number;
    fontSize: string;
    fontFamily: 'arv-open-sans' | 'arv-roboto';
    fontWeight: string;
    textAlignment: 'center' | 'left' | 'right';
}

export function asRoboto16(): IAnimatedButtonFontParams {
    const params: IAnimatedButtonFontParams = {
        heightInPx: 48,
        lineHeight: 24,
        fontSize: '1.6rem',
        fontFamily: 'arv-roboto',
        fontWeight: '900',
        textAlignment: 'center'
    };
    return params;
}

export function asSans16(): IAnimatedButtonFontParams {
    const params: IAnimatedButtonFontParams = {
        heightInPx: 48,
        lineHeight: 24,
        fontSize: '1.6rem',
        fontFamily: 'arv-open-sans',
        fontWeight: '400',
        textAlignment: 'center'
    };
    return params;
}

export function asSans12(): IAnimatedButtonFontParams {
    const params: IAnimatedButtonFontParams = {
        heightInPx: 20,
        lineHeight: 16,
        fontSize: '1.2rem',
        fontFamily: 'arv-open-sans',
        fontWeight: '400',
        textAlignment: 'center'
    };
    return params;
}